export default __webpack_public_path__ + "static/media/tuiju.88e17b98.png";